import addToMailchimp from 'gatsby-plugin-mailchimp'
import styled from "@emotion/styled"
import React, {Component} from "react"

const PurpleWrapper = styled.div`
    width: 100%;
    background-color: rgb(139,153,249,0.2);
    padding: 35px 35px 10px 35px;
    margin-top: 80px;
    text-align: center;
`

const SubscribeTitle = styled.h1`
    font-size: 1.5rem;

    ::before {
        display: none;
    }
`

const EmailField = styled.input`
    max-width: 450px;
    width: 100%;
    font-size: 1rem;
    line-height: 1.5rem;
    margin-top: .25rem;
    padding: .75rem;
    border: .0625rem solid #cdcfd5;
    border-radius: 0;
    overflow: visible;
    -webkit-writing-mode: horizontal-tb !important;
    text-rendering: auto;
    color: -internal-light-dark(black, white);
    letter-spacing: normal;
    word-spacing: normal;
    text-transform: none;
    text-indent: 0px;
    text-shadow: none;
    display: inline-block;
    text-align: start;
    appearance: textfield;
    background-color: -internal-light-dark(rgb(255, 255, 255), rgb(59, 59, 59));
    -webkit-rtl-ordering: logical;
    cursor: text;
    margin-top: -10px;
`

const SubscribeButton = styled.input`
    background-color: rgb(139,153,249,0.6);
    width: 10rem;
    height: 3rem;
    margin-top: 20px;
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.5rem;
    align-self: flex-start;
    appearance: none;
    border: none;
    transition: background-color .3s ease-out;
    cursor: pointer;

    :hover {
        background-color: rgb(139,153,249,1.0);
    }
`

class SubscribeForm extends Component {
    constructor(props) {
        super(props);
    }

    state = {
        email: null,
        sent: false,
        message: null
    }

    _handleChange = e => {
        this.setState({
            [`${e.target.name}`]: e.target.value,
        })
    }

    _handleSubmit = e => {
        e.preventDefault()


        addToMailchimp(this.state.email, {
            SOURCE: this.props.source
        })
            .then(({ msg, result }) => {
                if (result == 'success'){
                    this.setState({sent:true})
                }
                if (result !== 'success') {
                    this.setState({message:msg})
                    throw msg
                }
            })
            .catch(err => {
            })
    }

    render() {
        if (this.state.sent == true){
            return (

                <PurpleWrapper>
                    <SubscribeTitle>Thanks for subscribing!</SubscribeTitle>
                </PurpleWrapper>
                
                )
        }
        else {
            return (

                <PurpleWrapper>
                    <SubscribeTitle>Want to stay up to date?</SubscribeTitle>
                    <p>Leave your email address below to receive my newsletter!</p>
                    <div>
                        <form onSubmit={this._handleSubmit}>
                            <EmailField
                                type="email"
                                onChange={this._handleChange}
                                placeholder="email address"
                                name="email"
                            />
                            <div dangerouslySetInnerHTML={{__html: this.state.message}}></div>
                            <SubscribeButton type="submit" value="Subscribe" />
                        </form>
                    </div>
                </PurpleWrapper>
                
                )
        }
 }}

export default SubscribeForm;